import { Theme } from '@mui/material/styles'
import makeStyles from '@mui/styles/makeStyles'

export default makeStyles((theme: Theme) => ({
  paper: {
    borderColor: theme.palette.primary.main,
    borderWidth: 1,
    borderStyle: 'solid',
    marginBottom: theme.spacing(2),
    width: '100%'
  },

  table: {
    minWidth: 1050
  },

  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  },

  headCell: {
    color: theme.palette.primary.contrastText
  },

  cell: {
    color: theme.colors.gray14,
    fontFamily: theme.corporate.secondaryFont,
    fontSize: 12,
    lineHeight: '16px'
  },

  state: {
    padding: theme.spacing(0.5, 2),
    color: theme.colors.gray14,
    fontFamily: theme.corporate.secondaryFont,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
    borderRadius: '4px',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  initial: {
    backgroundColor: theme.colors.saffron050,
    width: '150px',
    textAlign: 'center'
  },

  signed: {
    backgroundColor: theme.colors.seaGreen050,
    width: '150px',
    textAlign: 'center'
  },

  rejected: {
    backgroundColor: theme.colors.persianRed050,
    width: '150px',
    textAlign: 'center'
  },

  firmadoEnOrigen: {
    backgroundColor: theme.colors.gray18,
    width: '150px',
    textAlign: 'center'
  },

  loader: {
    alignItems: 'center',
    display: 'flex',
    height: 400,
    justifyContent: 'center',
    width: '100%'
  },

  cellExpedient: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',

    '& > div': {
      marginBottom: '8px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      lineClamp: 3,
      boxOrient: 'vertical'
    }
  }
}))
